module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Semibold.2c151db5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/SFProDisplay-Semibold.woff
// module id = 334
// module chunks = 1